const containerStyles = {
  alignItems: "center",
  display: "flex",
  justifyContent: "flex-end"
};
export {
  containerStyles
};
